import Button from "./prop/Button"
import Marquee from "./prop/Marquee"

export default function Header() {
    return (
        <header>
            <div className="header-img"></div>
            <div className="header-container">
                <div className="header-infos-contact sansita f16">
                    <a href="mailto:contact@maestrom-digital.fr">contact@maestrom-digital.fr</a>
                    <p href="tel:+33676226473">06 76 22 64 73</p>
                </div>
                <div className="header-tagline-container">
                    <img src="./img/logo/logo-maestrom.png" alt="Logo de l'entreprise Maestrom création de site internet & projets digital" className="logo" />
                    <h3 className="tagline sansita f24">
                        Votre site internet professionnel à partir de 450€
                    </h3>
                    <Button label="Nos offres" color='red' href="#offres"/>
                </div>
                <div className="header-marquee-container">
                    <Marquee />
                    <p className="f36 sansita">7ans de création de sites internet</p>
                </div>
            </div>
        </header>
    )
}